import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

type Lang = "en" | "el";

const COPY = {
  en: {
    login: "restaurant login",
    motto: "the bill, without the wait.",
    demo: "See the demo",
    email: "hi@finally.cc",
    steps: [
      { title: "Scan the table", detail: "The QR opens the live check." },
      { title: "Split it their way", detail: "Equally, by item, or any amount." },
      { title: "Pay and go", detail: "Card on the phone, at the table." },
    ],
  },
  el: {
    login: "Σύνδεση εστιατορίου",
    motto: "ο λογαριασμός, χωρίς την αναμονή.",
    demo: "Δείτε το demo",
    email: "hi@finally.cc",
    steps: [
      { title: "Σκανάρετε το τραπέζι", detail: "Το QR ανοίγει τον λογαριασμό." },
      { title: "Χωρίστε τον όπως θέλετε", detail: "Ισόποσα, ανά είδος, ή όποιο ποσό." },
      { title: "Πληρώστε και φύγετε", detail: "Με κάρτα από το κινητό, στο τραπέζι." },
    ],
  },
} as const;

const storedLang = (): Lang => {
  const saved = localStorage.getItem("landingLang");
  return saved === "el" ? "el" : "en";
};

const LandingView: React.FC = () => {
  const [lang, setLang] = useState<Lang>(storedLang);
  const copy = COPY[lang];

  useEffect(() => {
    localStorage.setItem("landingLang", lang);
    document.documentElement.lang = lang === "el" ? "el" : "en";
  }, [lang]);

  return (
    <div className="landing">
      <div className="coming-soon">
        <img
          className="coming-soon-logo"
          src="/assets/images/logos/finally_logo.png"
          alt="Finally"
        />
        <p className="coming-soon-label">coming soon</p>
      </div>
      <div className="landing-underlay" aria-hidden="true">
      <header className="landing-nav">
        <div className="landing-lang" role="group" aria-label="Language">
          <button
            type="button"
            className={lang === "en" ? "is-active" : undefined}
            onClick={() => setLang("en")}
          >
            EN
          </button>
          <button
            type="button"
            className={lang === "el" ? "is-active" : undefined}
            onClick={() => setLang("el")}
          >
            ΕΛ
          </button>
        </div>
        <Link to="/login">{copy.login}</Link>
      </header>

      <main className="landing-main">
        <img
          className="landing-logo"
          src="/assets/images/logos/finally_logo.png"
          alt="Finally"
        />
        <p className="landing-motto">{copy.motto}</p>
        <Link to="/demo" className="landing-btn">
          {copy.demo}
        </Link>
        <ol className="landing-steps">
          {copy.steps.map((step) => (
            <li key={step.title}>
              <strong>{step.title}</strong>
              <span>{step.detail}</span>
            </li>
          ))}
        </ol>
      </main>

      <footer className="landing-footer">
        <a href={`mailto:${copy.email}`}>{copy.email}</a>
      </footer>
      </div>
    </div>
  );
};

export default LandingView;
